import axios from "axios"
import { UpdateConfiguracionPrestamoCommandProps } from "./Commands/UpdateConfiguracionPrestamoCommand"
import { UpdateEmpresaCommandProps } from "./Commands/UpdateEmpresaCommand"
import { UpdateDatosRegistroMercantilProps } from "./Commands/UpdateEmpresaConfiguracionRegistroMercantil"

/**
 * @description Obtiene validaciones pendientes para el usuario activo de la empresa.
 * @async
 * @function
 */

export async function putEmpresaConfiguracionPrestamo(
  configuracionesPrestamo: UpdateConfiguracionPrestamoCommandProps
) {
  await axios.put("/Empresa/configuracion/prestamo", configuracionesPrestamo)
}

export async function putEmpresaById(queryParams: UpdateEmpresaCommandProps) {
  // TODO: Endpoint. Verificar el motivo por el cual se se envía el mismo id en el body y en la url.
  await axios.put(`/Empresa/${queryParams?.id}`, queryParams)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function putEmpresaLogo({ logo }: $TSMigrationFixMe) {
  const bodyFormData = new FormData()
  const blob = new Blob([logo], { type: logo.type })
  bodyFormData.append("logo", blob, logo.name)

  return axios.put(`/Empresa/logo`, bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
}

export async function deleteEmpresaLogo() {
  return axios.delete(`/Empresa/logo`)
}

export async function validateValidations(nif: string) {
  const token = sessionStorage.getItem("access_token")
  const instancia = axios.create({
    baseURL: import.meta.env.REACT_APP_API_CERTIFICADOS,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
  return instancia.post(`/certification/check/nif/${nif}`)
}

export async function getEmpresaConfiguracionRegistroMercantilById(
  queryParams: string
): Promise<string> {
  const { data }: Record<"data", string> = await axios.get(
    `/EmpresaConfiguracion/empresa/${queryParams}/datos-registro-mercantil`
  )
  return data
}

export async function putEmpresaConfiguracionRegistroMercantilById(
  queryParams: UpdateDatosRegistroMercantilProps
) {
  const { empresaId, ...data } = queryParams
  await axios.put(
    `/EmpresaConfiguracion/empresa/${empresaId}/datos-registro-mercantil`,
    data
  )
}
